import { create } from 'zustand';

// How many `FixedBottomBar`s are showing. A counter for the same reason as `overlay.ts`: a route
// can mount more than one bar, and the bars report a `visible` prop rather than their mount, so
// shows and hides interleave.
type BottomBarStore = {
  visible: number;
  showBottomBar: () => void;
  hideBottomBar: () => void;
};

const useBottomBarStore = create<BottomBarStore>((set) => ({
  visible: 0,
  showBottomBar: () => set((state) => ({ visible: state.visible + 1 })),
  hideBottomBar: () => set((state) => ({ visible: Math.max(0, state.visible - 1) })),
}));

export const useIsBottomBarVisible = (): boolean => useBottomBarStore((state) => state.visible > 0);

export default useBottomBarStore;
